export default "https://cdn.questicon.mathletics.com/assets/images/mountain-19122c4f955fd76ed97397a6c800b839.svg";